import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRightLeftArrow = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15.0035 12.2375C14.7553 12.4857 14.3529 12.4857 14.1047 12.2375C13.8565 11.9893 13.8565 11.5869 14.1047 11.3387L16.8331 8.61024L5.65614 8.61025C5.30513 8.61025 5.02058 8.32569 5.02058 7.97468C5.02058 7.62366 5.30513 7.33911 5.65615 7.33911L16.8331 7.3391L14.1047 4.61068C13.8565 4.36247 13.8565 3.96005 14.1047 3.71185C14.3529 3.46364 14.7553 3.46364 15.0035 3.71185L18.8169 7.52526C18.9361 7.64445 19.0031 7.80611 19.0031 7.97467C19.0031 8.14324 18.9361 8.3049 18.8169 8.42409L15.0035 12.2375Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.59649 20.288C8.84469 20.5362 9.24711 20.5362 9.49532 20.288C9.74352 20.0398 9.74352 19.6374 9.49532 19.3892L6.76689 16.6608H17.9439C18.2949 16.6608 18.5794 16.3762 18.5794 16.0252C18.5794 15.6742 18.2949 15.3896 17.9439 15.3896L6.76689 15.3896L9.49532 12.6612C9.74352 12.413 9.74352 12.0106 9.49532 11.7624C9.24711 11.5142 8.84469 11.5142 8.59649 11.7624L4.78308 15.5758C4.66388 15.695 4.59692 15.8566 4.59692 16.0252C4.59692 16.1938 4.66388 16.3554 4.78308 16.4746L8.59649 20.288Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgRightLeftArrow);
export default ForwardRef;
